export default __webpack_public_path__ + "static/media/446.a20d2c1f.png";